const svgContext = require.context('./svg?raw', false, /\.svg$/);
const pngContext = require.context('./png/', false, /\.png$/);

export const svgIcons = {};
export const pngIcons = {};

export const addIcon = (ctx, acc) => {
    ctx.keys().forEach((key) => {
        const icon = ctx(key);
        if (icon.__esModule) {
            acc[key.slice(2, -4)] = icon.default;
        } else {
            acc[key.slice(2, -4)] = icon;
        }
    });
};

addIcon(svgContext, svgIcons);
addIcon(pngContext, pngIcons);

export default svgIcons;
